import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { PermissionService } from './permission.service';

const DENIED_TITLE = 'Yetkiniz Bulunmamaktadır';

@Injectable({ providedIn: 'root' })
export class PermissionActionService {
  private lastDeniedAt = 0;

  constructor(private permissionService: PermissionService) {}

  assertRead(permissionKey: string): boolean {
    if (!permissionKey || this.permissionService.hasRead(permissionKey)) {
      return true;
    }
    this.showDenied();
    return false;
  }

  assertWrite(permissionKey: string): boolean {
    if (!permissionKey || this.permissionService.hasWrite(permissionKey)) {
      return true;
    }
    this.showDenied();
    return false;
  }

  showDenied(): void {
    const now = Date.now();
    if (now - this.lastDeniedAt < 2500) {
      return;
    }
    this.lastDeniedAt = now;
    void Swal.fire({
      icon: 'warning',
      title: DENIED_TITLE,
      confirmButtonText: 'Tamam',
    });
  }
}
